import { getPlatform, isApp } from '@/utils/page';
import { getSite } from '@/utils/site';
import Cookies from 'js-cookie'


export function getChannel(){
	if(isApp()){
		return 'app'
	}
	return getPlatform().platform
}

export function getChannelNumber(){
	var channel
	var {platform}=getPlatform()
	if(isApp()){
		channel=4
	}else if(platform=='mob'){
		channel=5
	}else if(platform=='pc'){
		channel=2
	}
	return channel
}

export function getSiteNumber(){
	var site=getSite()
	var siteMap={
		US:1,
		RU:2,
		ES:4,
	}
	return siteMap[site]
}

export function getArriveId(){
	const arriveIdMap={
		US:2456,
		ES:2427,
		RU:2285,
	}
	var arriveId=arriveIdMap[getSite()]
	var {platform}=getPlatform()
	try{
		if(platform=='mob'){
			arriveId=Cookies.get("dest_country")||arriveId
		}
		if(platform=='pc'){
			arriveId=JSON.parse(Cookies.get("eptCountry")).id
		}	
	}catch(err){
		//
	}
	return arriveId
}